import React, { useEffect, useState } from "react"
import {
   GetProductionLineDetails,
   UpdateProductionLines,
} from "api/api.service"
import { DatePicker } from "components/DatePicker"
import { ConfiguratorPackagesStatus } from "constants"
import moment from "moment"
import toast from "react-hot-toast"
import ProductionLineSkeleton from "./ProductionLineSkeleton/ProductionLineSkeleton"
import ProductionLineInfoSkeleton from "./ProductionLineSkeleton/ProductionLineInfoSkeleton"
import ActiveInactiveSwitch from "pages/Configurator/CommonUI/ActiveInactiveSwitch/ActiveInactiveSwitch"
import { ConfiguratorStatus } from "constants"
import externalIcon from "assets/images/icons/external-link.svg"
import { APP_ROUTES } from "helpers/routeHelpers"
import { useHistory } from "react-router-dom"
const ProductionLineInfo = props => {
   const { productionDetails, isLoading = true, productionLineId } = props
   const history = useHistory()
   const [dates, setDates] = useState({ startDate: null, endDate: null })
   const [loading, setLoading] = useState(false)
   const [status, setStatus] = useState(ConfiguratorPackagesStatus.Inactive)
   useEffect(() => {
      if (productionDetails?.status) {
         setStatus(productionDetails?.status)
         setDates({
            startDate: productionDetails.startDate || null,
            endDate: productionDetails.endDate || null,
         })
      }
   }, [isLoading, productionDetails])

   const handleFetchProductionInfo = async () => {
      try {
         const res = await GetProductionLineDetails(productionLineId)
         return res
      } catch (error) {
         history.push(APP_ROUTES.PRODUCTION_LINE_MANAGEMENT)
         toast.error("Production Line does not exist!")
      }
   }

   const handleStatusChange = async currStatus => {
      try {
         const newStatus =
            currStatus === ConfiguratorStatus.Active
               ? ConfiguratorStatus.Inactive
               : ConfiguratorStatus.Active

         await UpdateProductionLines(productionDetails?.id, {
            status: newStatus,
         })
         const res = await handleFetchProductionInfo()
         setStatus(newStatus)
         toast.success("Production Line status updated successfully!")
      } catch (err) {
         console.error(err)
         setStatus(productionDetails?.status)
         toast.error("Failed to update production line status!")
      }
   }

   const handleDateChange = async (date, type) => {
      try {
         setLoading(true)

         const payload = {
            [type]: moment(date).utc().format("YYYY-MM-DD HH:mm:ss"),
         }

         await UpdateProductionLines(productionDetails?.id, payload)
         const res = await handleFetchProductionInfo()

         setDates({
            startDate: res?.startDate || dates.startDate,
            endDate: res?.endDate || dates.endDate,
         })

         toast.success(
            `Production Line ${
               type === "startDate" ? "Start" : "End"
            } Date Updated!`
         )
      } catch (err) {
         console.error(err)
         toast.error(
            `Failed to update Production Line ${
               type === "startDate" ? "Start" : "End"
            } Date`
         )
      } finally {
         setLoading(false)
      }
   }

   const handleNavigateToProductionSchedule = productionLineId => {
      history.push(APP_ROUTES.TIMELINE_PRODUCTION_SCHEDULE, {
         productionLineId,
      })
   }
   return isLoading ? (
      <ProductionLineSkeleton />
   ) : loading ? (
      <ProductionLineInfoSkeleton />
   ) : (
      <div className="px-4">
         <div className="d-flex justify-content-start align-items-center gap-1">
            <h1 className="mb-0">{productionDetails?.name}</h1>
            <div className="tooltip-container ">
               <span
                  className="text-success pointer"
                  onClick={() =>
                     handleNavigateToProductionSchedule(productionDetails?.id)
                  }
               >
                  <img
                     height={30}
                     width={30}
                     src={externalIcon}
                     className="production-line-info-external-link"
                  />
               </span>
               <span className="custom-tooltip">View Production Schedule</span>
            </div>
         </div>
         <div className="production-line-dates">
            <div className="mt-4 d-flex align-items-center gap-3">
               <div className="mt-1">Start Date</div>
               <div>
                  {" "}
                  <DatePicker
                     selected={
                        dates.startDate ? new Date(dates.startDate) : null
                     }
                     onChange={date => handleDateChange(date, "startDate")}
                     placeholderText="Select Start Date"
                     minDate={new Date()}
                     className="custom-date-picker custom-date-picker-disabled"
                     isLoading={loading}
                     disabled={true}
                  />
               </div>
            </div>
            <div className="mt-4 d-flex align-items-center gap-3">
               <div className="mt-1">End Date</div>
               <div>
                  {" "}
                  <DatePicker
                     selected={dates.endDate ? new Date(dates.endDate) : null}
                     onChange={date => handleDateChange(date, "endDate")}
                     placeholderText="Select End Date"
                     minDate={
                        dates.startDate
                           ? new Date(
                                moment(dates.startDate).utc()
                                   .add(1, "days")
                                   .format("YYYY-MM-DD")
                             )
                           : new Date()
                     }
                     className="custom-date-picker"
                     isLoading={loading}
                  />
               </div>
            </div>
         </div>
         <div className="mt-4 d-flex align-items-center gap-5">
            <div>Status</div>
            <ActiveInactiveSwitch
               isDisable={false}
               name={`production-line-status`}
               onChange={() => handleStatusChange(status)}
               isChecked={status === ConfiguratorPackagesStatus.Active}
            />
         </div>

         <div className="mt-4 d-flex align-items-center gap-5">
            <div>Slot Sequence Number</div>
            <div>{productionDetails?.startingSlotId ?? "-"}</div>
         </div>
      </div>
   )
}

export default ProductionLineInfo
